import { useEffect } from 'react';
import { Card, CardContent, Grid, TextField, Typography, Button } from '@mui/material';
import { FaEdit } from 'react-icons/fa'
import api from '../../services/api';
import { useState } from 'react';
import Notification from '../../components/Notification/Notification';
import { toBase64 } from '../utils/toBase64';
import { useNavigate, useParams } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { updateImage } from '../utils/updateImage';

const classes = {
  root: {
    flexGrow: 1,
    margin: 20,
    marginTop: 30
  },
  textTitle: {
    margin: 8,
    color: '#000',
    fontWeight: 600,
    marginBottom: 20
  },
  fullWidth: {
    width: '100%'
  },
  inputFile: {
    border: 'dashed 2px #BABABA',
    height: 55.972,
    borderRadius: 5,
    textAlign: 'center',
    backgroundColor:'#fff',
    display: 'flex',
    alignItems:'center',
    justifyContent:'center'
  },
  btnSubmit: {
    backgroundColor: '#1551B3',
    color: '#fff',
    borderRadius: 20,
    height: '45px',
    textTransform:'none',
    fontWeight: 'bold',
    fontSize: 15,
    marginTop:0,
    minWidth: '220px',
    display:'flex',
    gap:10
  },
  cardContainer:{
    backgroundColor: "#F5F5F5"
  },
  btnCancel: {
    backgroundColor: '#F5F5F5',
    color: '#174FB3',
    borderRadius: 20,
    height: '45px',
    textTransform:'none',
    fontWeight: 'bold',
    fontSize: 15,
    marginTop:0,
    minWidth: '220px'
  },
  inputFileLabel:{ 
    fontSize:12, 
    position: 'absolute',
    transform: 'translate(8px, -9px)', 
    color: "#656565", 
    background:"linear-gradient(180deg, rgba(245,245,245,1) 51%, rgba(255,255,255,1) 51%)", 
    width: 220, 
    textAlign:'center'
  }
}


export default function GroupEdit() {

  const navigate = useNavigate();
  const { id } = useParams();

  const [nameSecretary, setNameSecretary] = useState('');
  const [nameForCitizen, setNameForCitizen] = useState('');
  const [description, setDescription] = useState('');
  const [icon, setIcon] = useState();
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '', title: '' });
  const [isChangedIcon, setIsChangedIcon] = useState(false)
  const [inputIcon, setInputIcon] = useState(null)

  const iconFileInput = isChangedIcon || 
                         icon == null || 
                         icon=='' ? {width: '70%'} : {width: '128px'}

  useEffect(() => {
    api.get(`groups/${id}`)
      .then((response) => {
        const data = response.data;

        setNameSecretary(data.nameSecretary);
        setNameForCitizen(data.nameForCitizen);
        setDescription(data.description);
        console.log(data.picture)
        !icon && setIcon(data.picture.body);

      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          message: 'Os dados não puderam ser carregados com sucesso',
          type: 'error',
          title: 'Erro no carregamento dos dados'
        });
      })

  }, [id, icon])

  const handleSubmit = async (e) => {
    e.preventDefault();

    let data = {
      nameSecretary,
      nameForCitizen,
      description,
      priority: "Comum"
    };

    try {
      const base64 = await toBase64(icon);
      data.picture = {
        type: icon.type,
        body: base64,
        url: ""
      }
    } catch (err) { }

    api.patch(`/groups/${id}`, data)
      .then((response) => {
        setNotify({
          isOpen: true,
          message: 'Grupo editado com sucesso.',
          type: 'success',
          title: 'Editado'
        });

        setTimeout(() => navigate('/groupregister'), 500);

      })
      .catch((err) => {
        setNotify({
          isOpen: true,
          message: 'O sistema apresentou um erro no cadastro',
          type: 'error',
          title: 'Erro'
        });
      })
  }

  const handleCancel = () => {
    navigate('/groupregister')
  }


  return (
    <Card style={classes.root}>
      <CardContent style={classes.cardContainer}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2} alignItems="center" justifyContent="center">
            <Grid item xs={12} sm={12} lg={12}>
              <Typography variant="h5" align="center" style={classes.textTitle}>
                Editar Grupo
              </Typography>
            </Grid>

            <Grid item xs={12} sm={12} md={4} lg={4}>
              <TextField
                style={{backgroundColor:"#fff"}}
                label='Nome do Grupo da Secretaria'
                fullWidth
                required
                value={nameSecretary}
                onChange={(e) => setNameSecretary(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={4} lg={4}>
              <TextField
                style={{backgroundColor:"#fff"}}
                label='Nome do Grupo do Cidadão'
                fullWidth
                required
                value={nameForCitizen}
                onChange={(e) => setNameForCitizen(e.target.value)}
              />
            </Grid>

            <Grid style={{position:'relative'}} item xs={12} sm={12} md={4} lg={4}>
              <div style={classes.inputFileLabel}>Selecione um ícone para este grupo</div>
              <div style={classes.inputFile}>
                <div style={{display:'flex', alignItems: 'center', justifyContent:'center', width: '100%', gap: '10px'}}>
                    <input
                      style={iconFileInput}
                      accept="image/*"
                      label='Icone'
                      type='file'
                      onChange={(e) => {
                        updateImage(e.target.files[0], setInputIcon); 
                        setIcon(e.target.files[0]); 
                        setIsChangedIcon(true)
                      }
                      }
                    />
                    <div style={{height: '20%', height: '100%'}}>
                      <img src={isChangedIcon ? inputIcon : icon} width={30} height={30}/>
                    </div>
                  </div>
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12}>
              <TextField
                style={{ zIndex: 0, backgroundColor:'#fff' }}
                label='Descrição'
                multiline
                rows={4}
                fullWidth
                required
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Grid>

            <Grid item>
              <Button
                  variant='outlined'
                  style={classes.btnCancel}
                  onClick={handleCancel}
                  startIcon={<FaArrowLeft style={{ 'color': '#174FB3' }} />}
              >
                  Voltar
              </Button>
            </Grid>

            <Grid item>
              <Button variant='outlined' style={classes.btnSubmit} type='submit'>
                <FaEdit style={{height:'1.2rem', width: '1.2rem'}}/>
                Salvar
              </Button>
            </Grid>

          </Grid>
        </form>
      </CardContent>

      <Notification
        notify={notify}
        setNotify={setNotify}
      />

    </Card >


  );

}